import {
  ArrowDownToLine,
  Briefcase,
  Gauge,
  Handshake,
  Send,
  TrendingUp,
} from 'lucide-react';
import type {
  CarryPortfolioFigures,
  CarryPortfolioSummary,
} from '@/types/carryFund';
import type { CarryStat } from './CarryStatStrip';
import {
  currencySymbol,
  formatMultiple,
  formatThousands,
} from './carryFundValues';

export function portfolioStats(
  summary: CarryPortfolioSummary | CarryPortfolioFigures
): CarryStat[] {
  const symbol = currencySymbol(summary.currency);
  const inK = (amount: string) => `${symbol} ${formatThousands(amount)}k`;
  // Members don't get the fund's commitments and drawdowns.
  const fundStats: CarryStat[] =
    'committed' in summary
      ? [
          {
            icon: Handshake,
            label: 'Committed',
            value: inK(summary.committed),
          },
          {
            icon: ArrowDownToLine,
            label: 'Drawn',
            value: inK(summary.drawn),
            hint: `${inK(summary.undrawn)} undrawn`,
          },
        ]
      : [];

  return [
    ...fundStats,
    { icon: Briefcase, label: 'Invested', value: inK(summary.invested) },
    { icon: Send, label: 'Distributed', value: inK(summary.distributed) },
    { icon: TrendingUp, label: 'NAV', value: inK(summary.nav) },
    {
      icon: Gauge,
      label: 'MOM',
      value: summary.mom === null ? '—' : formatMultiple(summary.mom),
    },
  ];
}
